export enum AttendanceMethodTypes {
  day = 1,
  session = 2,
  subject = 3
}
